import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastService, ToastMessage } from './toast.service';

interface ActiveToast extends ToastMessage {
  id: number;
  visible: boolean;
}

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit, OnDestroy {

  toasts: ActiveToast[] = [];
  private subscription: Subscription;
  private idCounter = 0;

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.subscription = this.toastService.toast$.subscribe((toast: ToastMessage) => {
      this.addToast(toast);
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private addToast(toast: ToastMessage): void {
    const id = ++this.idCounter;
    const duration = toast.duration || 3000;

    const activeToast: ActiveToast = {
      ...toast,
      id: id,
      visible: false
    };

    this.toasts.push(activeToast);

    // Trigger animation after a small delay
    setTimeout(() => {
      activeToast.visible = true;
    }, 10);

    // Auto-remove after duration
    setTimeout(() => {
      this.removeToast(id);
    }, duration);
  }

  removeToast(id: number): void {
    const toast = this.toasts.find(t => t.id === id);
    if (toast) {
      toast.visible = false;
      // Remove from array after fade-out animation
      setTimeout(() => {
        this.toasts = this.toasts.filter(t => t.id !== id);
      }, 300);
    }
  }

  getIcon(type: string): string {
    switch (type) {
      case 'success': return 'check_circle';
      case 'error': return 'error';
      case 'warning': return 'warning';
      case 'info':
      default: return 'info';
    }
  }

}
